<!-- <app-progress-nav class="nav-bar" [totalSteps]="totalSteps"></app-progress-nav> -->
<div class="nav-bar">
  <img
    class="back"
    (click)="previousPage()"
    src="assets/authentication/back.svg"
    alt=""
  />
</div>
<app-credential
  class="main"
  style="right: 0"
  id="1Page"
  [pageNumber]="1"
  [currentPageNumber]="currentStep"
></app-credential>
<app-gender
  class="main"
  id="2Page"
  [pageNumber]="2"
  [currentPageNumber]="currentStep"
></app-gender>
<app-date
  class="main"
  id="3Page"
  [type]="'birthdate'"
  [Redesign]="true"
  [pageNumber]="3"
  [currentPageNumber]="currentStep"
></app-date>
<app-weight
  class="main"
  id="4Page"
  [type]="'current'"
  [pageNumber]="4"
  [Redesign]="true"
  [currentPageNumber]="currentStep"
></app-weight>
<app-height
  style="overflow-y: auto"
  class="main"
  id="5Page"
  [pageNumber]="5"
  [Redesign]="true"
  [currentPageNumber]="currentStep"
></app-height>
<!-- <app-referral-code
  class="main"
  id="6Page"
  [pageNumber]="6"
  [currentPageNumber]="currentStep"
></app-referral-code> -->
<app-submit-button [Redesign]="true" [title]="buttonTitle"></app-submit-button>
<app-loading *ngIf="showLoading"></app-loading>
